import imageCompression from 'browser-image-compression'
import { FFmpeg } from '@ffmpeg/ffmpeg'

export const extractDigitsFromString = (value: string) => {
  const onlyNumber = value.replace(/[^0-9]/g, '')
  return onlyNumber.startsWith('55') ? onlyNumber.slice(2) : onlyNumber
}

export const postBroadcastMessage = (name: string, message?: any) => {
  const broadcastChannel = new BroadcastChannel(name)
  broadcastChannel.postMessage(message || name)
  broadcastChannel.close()
}

let ffmpegInstance: FFmpeg | null = null

async function getFFmpeg(): Promise<FFmpeg> {
  if (ffmpegInstance) return ffmpegInstance

  const ffmpeg = new FFmpeg()

  try {
    await ffmpeg.load()
  } catch (e) {
    console.error('Falha ao carregar o FFmpeg', e)
  }

  ffmpegInstance = ffmpeg
  return ffmpeg
}

export async function compressMedia(file: File, targetSizeMB = 5): Promise<File> {
  const mimeType = file.type
  const sizeMB = file.size / (1024 * 1024)
  let resultFile = file

  if (mimeType.startsWith('image/') && sizeMB > targetSizeMB) {
    try {
      const compressed = await imageCompression(file, {
        maxSizeMB: targetSizeMB,
        useWebWorker: true
      })

      resultFile = new File([compressed], file.name, { type: mimeType })
    } catch (err) {
      console.error('Erro ao comprimir imagem:', err)
    }
  }

  if (mimeType.startsWith('video/') && sizeMB > targetSizeMB) {
    const ffmpeg = await getFFmpeg()

    const buffer = new Uint8Array(await file.arrayBuffer())
    try {
      await ffmpeg.writeFile(file.name, buffer)
    } catch (err) {
      console.error('Erro ao gravar arquivo de vídeo no FS:', err)
    }

    const outputName = file.name.replace('.mp4', '_compressed.mp4')
    const targetBitrate = Math.floor((targetSizeMB * 8 * 1024 * 1024) / 60)

    await ffmpeg.exec([
      '-i',
      file.name,
      '-c:v',
      'libx264',
      '-preset',
      'ultrafast',
      '-b:v',
      `${targetBitrate}`,
      '-movflags',
      'faststart',
      outputName
    ])

    const data = await ffmpeg.readFile(outputName)
    const blob = new Blob([data], { type: 'video/mp4' })

    return new File([blob], file.name.replace(/\.\w+$/, '') + '_compressed.mp4', {
      type: 'video/mp4',
      lastModified: Date.now()
    })
  }

  return resultFile
}
